import moment from 'moment';

export enum DateFormat {
  SIMPLE_DATE_FORMAT = 'DD-MM-YYYY HH:mm',
}

export const simpleDateFormatter = (date: Date): string => moment(date).format(DateFormat.SIMPLE_DATE_FORMAT);
